<span>
  <i
    class="fa fa-exclamation-triangle"
    aria-hidden="true"
    ngbTooltip="{{ 'COLMEC_TOOLTIP_AVAILABIITY_MISSING' | translate }}"
  >
  </i>

  {{ 'COLMEC_TOOLTIP_AVAILABIITY_MISSING' | translate }}
</span>
